export default "__VITE_ASSET__g4F4cJ$c__"